
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HomepageBackground extends Vue {
  get urlBase() {
    return process.client ? this.$route.fullPath : ''
  }
}
